import { render, staticRenderFns } from "./chart-locked.vue?vue&type=template&id=b3205ec6&scoped=true&"
import script from "./chart-locked.vue?vue&type=script&lang=ts&"
export * from "./chart-locked.vue?vue&type=script&lang=ts&"
import style0 from "./chart-locked.vue?vue&type=style&index=0&id=b3205ec6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3205ec6",
  null
  
)

export default component.exports